import { render, staticRenderFns } from "./adminkf4.vue?vue&type=template&id=6b569f8a"
import script from "./adminkf4.vue?vue&type=script&lang=js"
export * from "./adminkf4.vue?vue&type=script&lang=js"
import style0 from "./adminkf4.vue?vue&type=style&index=0&id=6b569f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports